
import { Stage, Persona, Scuola, Indirizzo, City } from '../api/types'


export const displayPersona = (p: Persona) => `${p.id} - ${p.nome} ${p.cognome}`
export const displayStage = (s: Stage) => `${s.anno} - ${s.titolo}`
export const displayCity = (c: City) => c.name;
export const displayIndirizzo = (i: Indirizzo) => `${displayCity(i.citta)} ${i.nome}`
export const displayScuola = (s: Scuola) => `${s.nome} - ${displayIndirizzo(s.indirizzo)}`
